import { render, staticRenderFns } from "./parent-permalink.vue?vue&type=template&id=3ad571aa&scoped=true"
import script from "./parent-permalink.vue?vue&type=script&lang=js"
export * from "./parent-permalink.vue?vue&type=script&lang=js"
import style0 from "./parent-permalink.vue?vue&type=style&index=0&id=3ad571aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad571aa",
  null
  
)

export default component.exports